// UI-only placeholder. Client-side validation lives in ./useForm (validation()).
// Kept so FormSignup's `import validate from "./ValidationInfo"` resolves, matching the source.
const validate = () => ({});

export default validate;
